import {
  SELECT_WHITELABEL,
  SELECT_CUSTOMER,
} from '../../constants/types'


export const INITIAL_STATE = {
  wlID: 0,
  cuID: 0,
  wlName: '',
  cuName: '',
}

export const Reducer = (state = INITIAL_STATE, { type, payload: { id, name } = {} }) => {
  switch (type) {
  case SELECT_WHITELABEL:
    return { ...state, wlID: id, wlName: name }
  case SELECT_CUSTOMER:
    return { ...state, cuID: id, cuName: name }
  default:
    return state
  }
}
